import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Animated } from 'react-native';
import { useDirection } from '../../Hooks/UseDirection';
import { shouldTransformElementsToRTL, transformElementsToRTL } from '../../../Helpers/RTL/RTL';
export const AnimatedView = React.forwardRef((props, ref) => {
    const [dir] = useDirection();
    if (shouldTransformElementsToRTL(dir === 'rtl')) {
        return _jsx(Animated.View, Object.assign({ dir }, props, { ref: ref, children: transformElementsToRTL(props.children) }));
    }
    return _jsx(Animated.View, Object.assign({ dir }, props, { ref: ref }));
});
